import { LOCALES } from 'utils/locale'

export const ARIA_LABEL = 'Reset answers'
export const DATA_TEST_ID = 'reset-button'
export const RESET = {
  [LOCALES.EN_US]: 'Reset',
  [LOCALES.ES_US]: 'Reiniciar',
}
